import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffect, useContext } from 'react';

const usePurchaseHeaderEvent = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent('carvana-page-load');
  }, [trackEvent]);
};

export default usePurchaseHeaderEvent;
